import React from 'react';
import styled from 'styled-components';
import { ModalShell } from './shell';
import { Btn } from './primitives';

const Body = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fsSm};
  color: ${({ theme }) => theme.textMuted};
  line-height: 1.55;
  white-space: pre-line;
`;

/**
 * Lightweight notice modal — replaces legacy purple fixed-position alert boxes.
 * Presentation only; parent owns open state and message copy.
 */
export default function NoticeDialog({ open, message, title, onClose }) {
  if (!open || !message) return null;

  const dialogTitle = title || 'Notice';

  return (
    <ModalShell
      title={dialogTitle}
      onClose={onClose}
      max="420px"
      foot={(
        <Btn type="button" $variant="ghost" onClick={onClose}>
          Close
        </Btn>
      )}
    >
      <Body>{message}</Body>
    </ModalShell>
  );
}
